import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { SupportViewAllPanel, SupportViewAllValues } from "../../components/SupportViewAllPanel/SupportViewAllPanel";
import { OperationActionProps } from "../OperationTypes";

export interface SupportViewAllProps extends OperationActionProps {
  incidentId: string | undefined;
  supportViewAllValues: SupportViewAllValues;
}

const SupportViewAll = (
  { targetId, supportViewAllValues, onCancel }: SupportViewAllProps,
): JSX.Element => (
  <SupportViewAllPanel
    targetId={targetId}
    supportViewAllValues={supportViewAllValues}
    onClose={() => { onCancel?.(); }}
    title={Messages.labels.viewAll()}
  />
);

export const newSupportViewAll = (
  props: SupportViewAllProps,
): JSX.Element => (<SupportViewAll {...props} />);
